const createRandomId = () => Math.random().toString(36).substring(2);
const CHAIN_NAMESPACES = {
  EIP155: "eip155",
  SOLANA: "solana",
  CASPER: "casper",
  XRPL: "xrpl",
  OTHER: "other"
};
// eip155 for all evm chains

/**
 * Custom network properties
 * @example isEIP1559Compatible: true etc.
 */

/**
 *
 */

export { CHAIN_NAMESPACES, createRandomId };
